import PrimaryTable from "../../components/Table/PrimaryTable"
import { useDispatch, useSelector } from "react-redux";
import { setCollection, setCollectionLoading } from "../../features/collection/collectionSlice";
import { Box } from "@mui/material";
import useCollectionColumns from "../../components/TableHeader/CollectionColumns";
import { useGetCollectionMutation } from "../../features/collection/collectionApi";

const CollectionCase = ({leadData}) => {

    const dispatch = useDispatch();
    
    const { collection, totalRowCount, iscollectionLoading } = useSelector((state) => state.collection);

    const columns = useCollectionColumns();
    

    const [getCollectionCase] = useGetCollectionMutation();

    const fetchData = async ({ pagination, sorting, columnFilters, globalFilter }) => {
            dispatch(setCollectionLoading(true));
            try {
              const res = await getCollectionCase({
                pageIndex: pagination.pageIndex,
                pageSize: pagination.pageSize,
                sorting,
                columnFilters,
                globalFilter,
                data: {
                  customerID: leadData?.customerID,leadID: leadData?.leadID,DB: leadData?.TAG
                },
              }).unwrap();
        
              dispatch(setCollection({ data: res?.data, totalRowCount: res?.data?.totalRowCount })); // Adjust if backend sends total count separately
            } catch (error) {
            } finally {
              dispatch(setCollectionLoading(false));
            }
    };

    return (
        <>
     
               <PrimaryTable
                                                             columns={columns}
                                                             data={collection}
                                                             isLoading={iscollectionLoading}
                                                             totalRowCount={totalRowCount}
                                                             fetchData={fetchData}
                />
        </>
    )

}


export default CollectionCase
